// pdf-viewer.js
import PDF from './pdf'

var PdfViewer = {};
PdfViewer.install = function (Vue, options) {
  // Vue.component('pdf',PDF)
  let PDFPlugin = Vue.extend(PDF);
  let vm = new PDFPlugin().$mount();
  document.body.appendChild(vm.$el);
  Vue.prototype.$showPDF = function (url) {
    console.info(url);
    vm.showPDF(url);
  };
}
// module.exports = PdfViewer;
export default PdfViewer;



// WEBPACK FOOTER //
// ./src/components/pdf-viewer/pdf-viewer.js